function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect, useRef } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
import { STATUSES } from 'researcher/digital-editing/constants';
import featureEnabled from 'shared/helper/feature';
import { formatAsTimeAgo } from '../helpers/date';
import { NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES } from '../constants';
var RubriqDocumentCardStatus = function RubriqDocumentCardStatus(_ref) {
  var document = _ref.document,
    _ref$isTranslation = _ref.isTranslation,
    isTranslation = _ref$isTranslation === void 0 ? false : _ref$isTranslation;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    creationDateText = _useState2[0],
    setCreationDateText = _useState2[1];
  var intervalRef = useRef(null);
  var processing = document.status === STATUSES.STATUS_PROCESSING;
  var failed = document.status === STATUSES.STATUS_FAILED;
  var completed = document.status === STATUSES.STATUS_COMPLETED;
  var rubriqNewLewisVersionEnabled = featureEnabled('rubriq_lewis_version');
  var fromWordAddin = !isTranslation && document.origin === 'wai';
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;

  // set up a timer to make sure the text related to the document creation date is updated automatically
  useEffect(function () {
    setCreationDateText(formatAsTimeAgo(document.createdAt, t));
    intervalRef.current = setInterval(function () {
      setCreationDateText(formatAsTimeAgo(document.createdAt, t));
    }, NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES * 1000);
    return function () {
      return clearInterval(intervalRef.current);
    };
  }, [document.createdAt]);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center rubriq-text-document-status"
  }, processing && /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }), /*#__PURE__*/React.createElement(T, {
    source: "processing"
  }), /*#__PURE__*/React.createElement(Popover, {
    content: isTranslation ? 'curie.processing-translation-tooltip' : 'curie.processing-editing-tooltip',
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info"
  }))), failed && /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, /*#__PURE__*/React.createElement(T, {
    source: "unknown-error-".concat(isTranslation ? 'translation' : 'editing', "-card-title")
  })), /*#__PURE__*/React.createElement(Popover, {
    content: "unknown-error-".concat(isTranslation ? 'translation' : 'editing', "-card-tooltip"),
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info",
    className: "text-danger"
  }))), completed && /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: isTranslation ? 'translated' : 'edited'
  }), /*#__PURE__*/React.createElement(Popover, {
    content: isTranslation ? 'curie.completed-translation-tooltip' : 'curie.completed-editing-tooltip',
    params: isTranslation ? {
      language: t(document.language),
      styleOfEnglish: t(document.styleOfEnglish || 'American English')
    } : document.styleOfEnglish,
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, rubriqNewLewisVersionEnabled && !isTranslation && document.styleOfEnglish && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, t(document.styleOfEnglish))), rubriqNewLewisVersionEnabled && !isTranslation && document.version && (document.version === '1.7.0' || document.version === '1.8.4') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, document.version === '1.7.0' ? /*#__PURE__*/React.createElement(T, {
    source: "rubriq.moderate-edits"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.high-edits"
  }))), "\xB7", /*#__PURE__*/React.createElement("span", null, creationDateText, "\xA0", fromWordAddin && /*#__PURE__*/React.createElement(T, {
    source: "from word add-in"
  }))));
};
export default RubriqDocumentCardStatus;